import { useContext } from "react";
import { AuthContext } from "./context";


export default function useAuth() {
    const auth = useContext(AuthContext);
    
    if(auth === null) {
        throw new Error("Implementation error, auth provider required as a parent node")
    }
    return auth
}